import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import sharesTableSlice from "./slices/tables/nominalSharesTable";
import modalsSlice from "./slices/modals";
import companyOfficialsSlice from "./slices/tables/companyOfficialsSlice";
import jointShareholderTableSlice from "./slices/tables/jointShareholderTable";
import sharesAllocationTableSlice from "./slices/tables/sharesAllocationTable";
import shareAuthorizationSlice from "./slices/shareCapitalAuthorization";
import beneficialOwnersTableSlice from "./slices/tables/beneficialOwnersTableSlice";
import corporateShareholderTableSlice from "./slices/tables/corporateShareholderTableSlice";
import corporateJointShareholderTableSlice from "./slices/tables/corporateJointShareholderTableSlice";
import companiesSlice from "./slices/companies";
import authSlice from "./slices/auth";
import userSlice from "./slices/user";
import profileUpdateSlice from "./slices/profileUpdate";
import companySlice from "./slices/company";
import registeredOfficeSlice from "./slices/registeredOffice";
import reviewersTable from "./slices/tables/reviewersTable";
import commentsSlice from "./slices/comment";
import resolveField from "./slices/resolveField";
import accessRequestsSlice from "./slices/accessRequest";
import accessRequestComments from "./slices/accessRequestComment";
import organizationsSlice from "./slices/organizations";
import partnersSlice from "./slices/tables/partnersSlice";
import companyDashboardSlice from "./slices/companyDashboard";
import historyCompanyDashboardSlice from "./slices/historyCompanyDashboard";
import verifyInviteSlice from "./slices/verifyInvite";
import professionalDetailsSlice from "./slices/professionalDetails";
import organizationDashboardSlice from "./slices/organizationDashboard";
import permissionSlice from "./slices/permission";
import roleSlice from "./slices/role";
import contactPersonCorporatesSlice from "./slices/contactPersonCorporates";
import corporatesForDashboardSlice from "./slices/corporatesForDashboard";
import superAdminSlice from "./slices/superAdmin";
import orgAdminSlice from "./slices/orgAdmin";
import statsSlice from "./slices/stats";
import activeDashboardSlice from "./slices/activeDashboard";
import productSlice from "./slices/product";
import packageSlice from "./slices/package";
import subscriptionSlice from "./slices/subscription";
import discountSlice from "./slices/discount";
import discountAssigneeSlice from "./slices/discountAssignee";
import invoiceSlice from "./slices/invoice";
import orderSlice from "./slices/order";
import transactionsSlice from "./slices/transactions";
import templateCategory from "./slices/templateCategory";
import templateSlice from "./slices/template";
import minuteBookSlice from "./slices/minuteBook";
import coApplicantSlice from "./slices/coApplicant";
import initiatedTransactionsSlice from "./slices/initiateTransactionChange";
import templateFileSlice from "./slices/templateFile";
import employeeSlice from "./slices/employee";
import transactionSlice from "./slices/transaction";
import esignatureSlice from "./slices/esignature";
import batchNumberSlice from "./slices/batchNumber";
import shareAllotmentSlice from "./slices/shareCapitalAllotment";
import shareConsolidationAndSubdivisionSlice from "./slices/shareConsolidationAndSubdivision";
import manualShareAllocationSlice from "./slices/manualShareAllocation";
import companiesTransactionsSlice from "./slices/companiesTransactions";
import transferYourBusinessSlice from "./slices/transferYourBusiness";
import paystackSlice from "./slices/paystack";
import roleswitchSlice from "./slices/roleswitch";
import corporateSlice from "./slices/corporate";

const appReducer = combineReducers({
  esignatureSlice,
  sharesAllocationTableSlice,
  shareAuthorizationSlice,
  sharesTableSlice,
  shareAllotmentSlice,
  shareConsolidationAndSubdivisionSlice,
  manualShareAllocationSlice,
  modalsSlice,
  companyOfficialsSlice,
  jointShareholderTableSlice,
  beneficialOwnersTableSlice,
  corporateShareholderTableSlice,
  corporateJointShareholderTableSlice,
  companiesSlice,
  authSlice,
  userSlice,
  profileUpdateSlice,
  companySlice,
  registeredOfficeSlice,
  reviewersTable,
  commentsSlice,
  resolveField,
  accessRequestsSlice,
  accessRequestComments,
  organizationsSlice,
  partnersSlice,
  companyDashboardSlice,
  historyCompanyDashboardSlice,
  verifyInviteSlice,
  professionalDetailsSlice,
  organizationDashboardSlice,
  permissionSlice,
  roleSlice,
  contactPersonCorporatesSlice,
  corporatesForDashboardSlice,
  superAdminSlice,
  orgAdminSlice,
  statsSlice,
  activeDashboardSlice,
  productSlice,
  packageSlice,
  subscriptionSlice,
  discountSlice,
  discountAssigneeSlice,
  invoiceSlice,
  orderSlice,
  transactionsSlice,
  templateCategory,
  templateSlice,
  minuteBookSlice,
  coApplicantSlice,
  initiatedTransactionsSlice,
  templateFile: templateFileSlice,
  employeeSlice,
  transactionSlice,
  batchNumberSlice,
  companiesTransactionsSlice,
  transferYourBusinessSlice,
  paystackSlice,
  roleswitchSlice,
  corporateSlice,
});

const reducerProxy = (state, action) => {
  if (action.type === "auth/logout") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: reducerProxy,
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
